import { InjectionToken } from '@angular/core';
import { LabTestResult } from '../lab-test-results/lab-test-result';
import { LinkParams } from '../covance-ag-grid';
import { StandardTestResultsItem } from '../on-screen-results/standard-test-results/standard-test-results.component';

export const LAB_TEST_RESULTS_LINK_BUILDER = new InjectionToken<LabTestResultsLinkBuilder>('LabTestResultLinkBuilder');

export interface LabTestResultsLinkBuilder {
    getAccessionNumberLink(lab: LabTestResult): LinkParams;
    getTestLink(lab: LabTestResult): LinkParams;
    getSubjectLink(params: StandardTestResultsItem): any[];
}